import { useGetIssuedCredentialByIdQuery } from "@/src/graphql/generated/api/graphql";
import { ValidatedQuestionDetailRoute } from "@/src/providers/router/router";
import Container from "@mui/material/Container";
import { Stack } from "@mui/material";
import InfoBlock from "../atoms/InfoBlock/InfoBlock";
import { useTranslation } from "react-i18next";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { dracula as SyntaxHighlighterStyle } from "react-syntax-highlighter/dist/cjs/styles/prism";
const ValidatedQuestionDetail = () => {
    const { t } = useTranslation("common", {
        keyPrefix: "info-box",
    });

    const { id } = ValidatedQuestionDetailRoute.useParams();

    const { data, loading, error } = useGetIssuedCredentialByIdQuery({
        variables: { getIssuedCredentialByIdId: id },
    });

    if (error) {
        console.error("Error fetching validated question detail:", error);
        return <div>Error loading validated question detail.</div>;
    }

    if (loading) {
        return <div>Loading...</div>;
    }

    const { exchangeProfile, issuedAt, nutsId, shacl, sparql, user } =
        data?.getIssuedCredentialById || {};

    return (
        <Container component={"section"} maxWidth="md">
            <Stack
                spacing={1}
                display={"flex"}
                flexDirection="column"
                alignItems="start"
                justifyContent={"flex-start"}
            >
                <h1>Validated Question Detail</h1>
                <InfoBlock label={t("nuts-id")} value={nutsId || ""} />
                <InfoBlock
                    label={t("gebruiker")}
                    value={`${user?.firstName} ${user?.lastName}`}
                />
                <InfoBlock
                    label={t("issued-at")}
                    value={new Date(issuedAt).toLocaleString() || ""}
                />
                <InfoBlock
                    label={t("exchange-profile")}
                    value={exchangeProfile || ""}
                />
                <InfoBlock label={t("shacl")} />
                {shacl && (
                    <SyntaxHighlighter
                        style={SyntaxHighlighterStyle}
                        language="sparql"
                        customStyle={{ fontSize: 14, maxWidth: "100%" }}
                    >
                        {shacl || ""}
                    </SyntaxHighlighter>
                )}
                <InfoBlock label={t("sparql")} />
                {sparql && (
                    <SyntaxHighlighter
                        style={SyntaxHighlighterStyle}
                        language="sparql"
                        customStyle={{ fontSize: 14, maxWidth: "100%" }}
                    >
                        {sparql || ""}
                    </SyntaxHighlighter>
                )}
            </Stack>
        </Container>
    );
};

export default ValidatedQuestionDetail;
